import { Component } from "react";
import { WithChildren } from "_metronic/helpers";

type State = { hasError: boolean };

// Sits above the router and redux, so the fallback uses plain links and full page loads
class AppErrorBoundary extends Component<WithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch() {
    // The app can crash before it hides the loading screen
    document.body.classList.remove("page-loading");
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="d-flex flex-column flex-center min-vh-100 text-center p-10">
        <a href="/" className="mb-10" data-test-id="app-error-boundary__logo-link">
          <img alt="Logo" className="logo-default cpl-brand-logo h-125px d-inline-block" />
        </a>
        <div className="fw-bold fs-3 text-gray-400 mb-15">
          Something went wrong! <br /> Please reload the page or try again later.
        </div>
        <button
          type="button"
          className="cpl-btn btn-lg cpl-btn-primary"
          onClick={() => window.location.reload()}
          data-test-id="app-error-boundary__reload-button"
        >
          Reload page
        </button>
      </div>
    );
  }
}

export { AppErrorBoundary };
